module.exports = __webpack_public_path__ + "static/img/plan3.66e1bf9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/plan3.png
// module id = 2a7J
// module chunks = 0